import type { Locale } from '@/lib/ist'

const rules: Record<Locale, Intl.PluralRules> = {
  en: new Intl.PluralRules('en-IN'),
  hi: new Intl.PluralRules('hi-IN'),
}

/** 'one' or 'other' for a count in this language (Hindi treats 0 and 1 as one). */
export function pluralCategory(locale: Locale, count: number): 'one' | 'other' {
  return rules[locale].select(count) === 'one' ? 'one' : 'other'
}

/** Pick the singular or plural form for a count: `plural('en', 1, 'bag', 'bags')` → 'bag'. */
export function plural(locale: Locale, count: number, one: string, other: string): string {
  return pluralCategory(locale, count) === 'one' ? one : other
}

/**
 * `{count:bag|bags}` in a message picks a form by the number in `count`. The number itself is
 * written separately with `{count}`, so a message reads '{count} {count:bag|bags} to go'.
 */
export const PLURAL_PATTERN = /\{(\w+):([^{}|]*)\|([^{}|]*)\}/g

export function applyPlurals(
  locale: Locale,
  template: string,
  vars: Record<string, string | number>,
): string {
  return template.replace(PLURAL_PATTERN, (match, name: string, one: string, other: string) => {
    if (!(name in vars)) return match
    const n = Number(vars[name])
    return Number.isFinite(n) ? plural(locale, n, one, other) : other
  })
}
